/*eslint-disable*/
import format from 'timestamp-format';
import moment from 'moment'
function userName(name) {
  name=name.toString();
  return name.slice(0,2) + '***' + name.slice(-2);
  // return name.slice(0,3) + new Array(name.length-4).join('*') + name.slice(-2);
}

function toName(name) {
  name=name+'';
  return new Array(name.length).join('*') + name.substr(-1);
}

function idNumber(name) {
  if(!name){
    return ''
  }
  name = name+'';
  return name.substr(0, 3) + ' ***** ***** ***** ' + name.substr(16, 18)
}
function birthdayNumber(num) {
  if(!num){
    return ''
  }
  let start,mid,end;
  num = num.toString();
  num = num.slice(6,14);
  start = num.slice(0,4);
  mid = num.slice(4,6);
  end = num.slice(6,8);
  num = start+'年'+mid+'月'+end + '日';
  return num
}
function formatPhone(phone) {
  phone = phone+'';
  return phone.substr(0, 3) + ' **** ' + phone.substr(7, 11);
}
function bankNumber(num) {
  num = num+'';
  if(num.length===19){
    return ' **** **** **** **** ' + num.substr(16, 19);
  }else if(num.length===18){
    return ' **** **** **** ' + num.substr(12, 18);
  }else if(num.length===16){
    return ' **** **** **** ' + num.substr(12, 16);
  }else if(num.length===17){
    return ' **** **** **** ' + num.substr(12, 17);
  }
}
function INbankNumber(num) {
    // num = num+'';
    return '**** **** **** ' + num.substring(num.length-4);
}
function emailNum(num){
  return num>99?'+99':num
}
// 提现申请的状态
function withdrawalStatus(type) {
  let S = "";
  switch (type) {
    case "0":
      return "申请中";
    case "1":
      return "出款中";
    case "2":
      return "成功";
    case "3":
      return "拒绝";
    case "4":
      return "出款中";
    case "5":
      return "出款中";
  }
  return S;
}
function gameName(type) {
  let S = "";
  switch (type) {
    case "1":
      return "老虎机";
    case "2":
      return "真人";
    case "3":
      return "体育";
    case "4":
      return "彩票";
    case "5":
      return "捕鱼王";
    case "6":
      return "棋牌";
    case "7":
      return "3D厅";

    default:
  }
  return S;
}
function gameName2(type) {
  let S = "";
  switch (type) {
    case "1":
      return "电子";
    case "2":
      return "真人";
    case "3":
      return "体育";
    case "4":
      return "彩票";
    case "5":
      return "捕鱼";
    case "6":
      return "棋牌";
    case "7":
      return "3D厅";

    default:
  }
  return S;
}

function changeTitle(val) {
  if(val==='0'){
    return '申请中'
  }else if(val==='1'){
    return '系统调帐'
  }else if(val==='2'){
    return '充值存款'
  }else if(val==='3'){
    return '秒速取款'
  }else if(val==='4'){
    return '转入游戏'
  }else if(val==='5'){
    return '游戏转出'
  }else if(val==='8'){
    return '优惠红利'
  }else if(val==='9'){
    return '人工存入'
  }else if(val==='10'){
    return '人工取出'
  }
}

function getTimeMS(time) {
  // return format('yyyy-MM-dd hh:mm:ss',time)
  return moment(time).format("YYYY-MM-DD HH:mm:ss");
}
// function INgetTimeMS(time) {
//   return moment(time).format("YYYY-MM-DD HH:mm:ss");
// }
function getTimeYDMS(time) {
  return format('yyyy/MM/dd hh:mm:ss',time)
}
function getTimeYDMS_(time) {
  return format('MM/dd hh:mm:ss',time)
}
function getTimeYMDS(time) {
  return format('yyyy年MM月dd日 hh:mm:ss',time)
}
function getTimeMD(time) {
  return format('yyyy-MM-dd ',time)
}
function getTimeMDSlash(time) {
  return format('yyyy/MM/dd ',time)
}
function getTimeMDSlash_(time) {
  return format('dd/MM/yyyy ',time)
}
function getTimehms(time) {
  return format('hh:mm',time)
}
function getTimehms_(time) {
  return format('hh:mm:ss',time)
}
// 体育日期
function getTimeYMDSports(time) {
  time = time.split('(')[1];
  time = time.split(')')[0];
  time = parseInt(time)
  return format('yyyy/MM/dd ',time)
}
function getTimeYMD(time) {
  return format('yyyy-MM-dd hh:mm',time)
}
function bonusTypes(type) {
  if(type==='0'){
    return '前置红利'
  }else if(type==='1'){
    return '后置红利'
  }else if(type==='2'){
    return '减去红利'
  }
}
// 红利类型
function bonusName(type) {
  let type1 = '';
  switch (type) {
    case "1":
      type1 = "返水红利";
      return type1;
    case "2":
      type1 = "存款优惠";
      return type1;
    case "3":
      type1 = "邀请奖励";
      return type1;
    case "4":
      type1 = "签到奖励";
      return type1;
    case "6":
      type1 = "连续存款优惠";
    case "7":
      type1 = "注册优惠";
      return type1;
    case "A":
      type1 = "救援金";
      return type1;
    case "B":
      type1 = "VIP升级奖励";
      return type1;
    case "C":
      type1 = "VIP蝉联奖励";
      return type1;
    default:
      type1 = "其他优惠";
      return type1;
  }
}
// 红利锁定状态
function bonusLockStatus(status) {
  let type1 = '';
  switch (status) {
    case "1":
      type1 = "锁定中";
      return type1;
    case "2":
      type1 = "已解锁";
      return type1;
    case "4":
      type1 = "已取消";
      return type1;

    default:
      type1 = "锁定中";
      return type1;
  }
}
// 红利锁定平台
function bonusLockPlatform(platform) {
  let type1 = '';
  switch (platform) {
    case "-1":
      type1 = "主账户";
      return type1;
    default:
      type1 = platform;
      return type1;
  }
}
// 存款锁定状态
function depositLockStatus(status) {
  let type1 = '';
  switch (status) {
    case "0":
      type1 = "锁定中";
      return type1;
    case "1":
      type1 = "已解锁";
      return type1;
    default:
      type1 = "锁定中";
      return type1;
  }
}


// 红利状态
function changeName(val) {
  // filterType:状态 -1=全部 0:申请中，1:进行中，2:成功发放，3:拒绝，4:失败，5未领取，6未抽中
  // filterType:状态 -1=全部 0:申请中，1:成功领取，2:完成流水，3:拒绝，4:清除稽核，5未领取，6未抽中
  if(val==='0'){
    return '申请中'
  }else if(val==='1'){
    return '成功领取'
  }else if(val==='2'){
    return '完成流水'
  }else if(val==='3'){
    return '拒绝'
  }else if(val==='4'){
    return '清除稽核'
  }else if(val==='5'){
    return '未领取'
  }else if(val==='6'){
    return '未抽中'
  }
}
function invitationStatus(type) {
  if(type==='0'){
    return 'invitation.unregistered'
  }else if(type==='1'){
    return 'invitation.registered'
  }else if(type==='2'){
    return 'invitation.expired'
  }
}
// 存款订单状态
function depositOrderStatus(type) {
  if(type==='0'){
    return '未支付'
  }else if(type==='1'){
    return '已支付'
  }else if(type==='2'){
    return '已过期'
  }
}
// 金额格式化
function formatCurrency(num) {
  num = num.toString().replace(/\$|\,/g,'');
  if(isNaN(num))
    num = "0";
  let sign = (num == (num = Math.abs(num)));
  num = Math.floor(num*100+0.50000000001);
  let cents = num%100;
  num = Math.floor(num/100).toString();
  if(cents<10)
    cents = "0" + cents;
  for (var i = 0; i < Math.floor((num.length-(1+i))/3); i++)
    num = num.substring(0,num.length-(4*i+3))+','+
      num.substring(num.length-(4*i+3));
  return (((sign)?'':'-') + num + '.' + cents);
}

//电子游戏类型
function slotgameType(val) {
  if(val){
    if(val=='1'){
      return '累积奖池'
    }else if(val=='2'){
      return '经典老虎机'
    }else if(val=='3'){
      return '消消乐'
    }else if(val=='4'){
      return '电动吃角子'
    }else if(val.length >1){
      let str = val.substring(0,1);
      if(str=='1'){
        return '累积奖池'
      }else if(str=='2'){
        return '经典老虎机'
      }else if(str=='3'){
        return '消消乐'
      }else if(str=='4'){
        return '电动吃角子'
      }
    }
  }
}


// 国际化
// 交易类型
function INchangeTitle(val) {
  if(val==='0'){
    return "filter.changeTitle.name0"
  }else if(val==='1'){
    return "filter.changeTitle.name1"
  }else if(val==='2'){
    return "filter.changeTitle.name2"
  }else if(val==='3'){
    return "filter.changeTitle.name3"
  }else if(val==='4'){
    return "filter.changeTitle.name4"
  }else if(val==='5'){
    return "filter.changeTitle.name5"
  }else if(val==='6'){
    return "filter.changeTitle.name6"
  }else if(val==='7'){
    return "filter.changeTitle.name7"
  }else if(val==='8'){
    return "filter.changeTitle.name8"
  }else if(val==='9'){
    return "filter.changeTitle.name9"
  }else if(val==='10'){
    return "filter.changeTitle.name10"
  }else if(val==='11'){
    return 'filter.changeTitle.name11'
  }else if(val==='12'){
    return 'filter.changeTitle.name12'
  }else if(val==='13'){
    return 'filter.changeTitle.name13'
  }else if(val==='14'){
    return 'filter.changeTitle.name14'
  }else if(val==='16'){
    return 'filter.changeTitle.name16'
  }else if(val==='17'){
    return 'filter.changeTitle.name17'
  }else if(val==='18'){
    return 'filter.changeTitle.name18'
  }else if(val==='19'){
    return 'filter.changeTitle.name19'
  }else if(val==='20'){
    return 'filter.changeTitle.name20'
  }else if(val==='21'){
    return 'filter.changeTitle.name21'
  }else if(val==='22'){
    return 'filter.changeTitle.name22'
  }else if(val==='23'){
    return 'filter.changeTitle.name23'
  }else if(val==='24'){
    return 'filter.changeTitle.name24'
  }else if(val==='30'){
    return 'filter.changeTitle.name30'
  }else if(val==='90'){
    return 'filter.changeTitle.name90'
  }else if(val==='91'){
    return 'filter.changeTitle.name91'
  }else if(val==='92'){
    return 'filter.changeTitle.name92'
  }else if(val==='93'){
    return 'filter.changeTitle.name93'
  }else if(val==='40'){
    return 'filter.changeTitle.name40'
  }else if(val==='41'){
    return 'filter.changeTitle.name41'
  }else if(val==='100'){
    return "filter.changeTitle.name100"
  }
}

// 支付订单状态
function INdepositstatus(type) {
  switch (type) {
    case "0":
      return "filter.status0";
    case "1":
      return "filter.status1";
    case "2":
      return "filter.status2";
    case "3":
      return "filter.status3";
    default:
  }
}

function INgameName(type) {
  let S = "";
  switch (type) {
    case "1":
      return "filter.gameName.name1";
    case "2":
      return "filter.gameName.name2";
    case "3":
      return "filter.gameName.name3";
    case "4":
      return "filter.gameName.name4";
    case "5":
      return "filter.gameName.name5";
    case "6":
      return "filter.gameName.name6";
    case "7":
      return "filter.gameName.name7";

    default:
  }
  return S;
}
// 红利类型
function INbonusName(type) {
  let type1 = '';
  switch (type) {
    case "1":
      type1 = "filter.bonusName.rebateBonus";
      return type1;
    case "2":
      type1 = "filter.bonusName.depositDiscount";
      return type1;
    case "3":
      type1 = "filter.bonusName.Invitation";
      return type1;
    case "4":
      type1 = "filter.bonusName.signin";
      return type1;
    case "6":
      type1 = "filter.bonusName.ContinuousDeposit";
    case "7":
      type1 = "filter.bonusName.register";
      return type1;
    case "A":
      type1 = "filter.bonusName.RescueFund";
      return type1;
    case "B":
      type1 = "filter.bonusName.UpgradeAward";
      return type1;
    case "C":
      type1 = "filter.bonusName.WinningAwards";
      return type1;
    default:
      type1 = "filter.bonusName.OtherPreferences";
      return type1;
  }
}
// 红利锁定平台
function INbonusLockPlatform(platform) {
  let type1 = '';
  switch (platform) {
    case "-1":
      type1 = "filter.bonusLockPlatform.mineAccount";
      return type1;
    default:
      type1 = platform;
      return type1;
  }
}
// 红利锁定状态
function INbonusLockStatus(status) {
  let type1 = '';
  switch (status) {
    case "1":
      type1 = "filter.bonusLockStatus.status1";
      return type1;
    case "2":
      type1 = "filter.bonusLockStatus.status2";
      return type1;
    case "4":
      type1 = "filter.bonusLockStatus.status4";
      return type1;

    default:
      type1 = "filter.bonusLockStatus.status1";
      return type1;
  }
}
// 存款锁定状态
function INdepositLockStatus(status) {
  let type1 = '';
  switch (status) {
    case "0":
      type1 = "filter.depositLockStatus.status1";
      return type1;
    case "1":
      type1 = "filter.depositLockStatus.status2";
      return type1;
    default:
      type1 = "filter.depositLockStatus.status3";
      return type1;
  }
}

//  红绿灯类型
function INColorLightStatus(type) {
  let S = "";
  switch (type) {
    case 0:
      return "betting.trafficList.0";
    case 10:
      return "betting.trafficList.10";
    case 11:
      return "betting.trafficList.11";
    case 12:
      return "betting.trafficList.12";
  }
  return S;
}

// 投注记录状态
function gameHistoryStatus(type) {
  let S = "";
  switch (type) {
    case '0':
      return "ghistory.Running";
    case '1':
      return "ghistory.Settled";
  }
  return S;
}

export default {
  formatPhone: formatPhone,
  toName: toName,
  bankNumber: bankNumber,
  changeName: changeName,
  changeTitle: changeTitle,
  getTimeMS: getTimeMS,
  getTimeYDMS: getTimeYDMS,
  getTimeMD: getTimeMD,
  bonusTypes: bonusTypes,
  bonusLockStatus,
  bonusLockPlatform,
  depositLockStatus,
  bonusName: bonusName,
  invitationStatus: invitationStatus,
  idNumber: idNumber,
  getTimeMDSlash: getTimeMDSlash,
  getTimeYMD: getTimeYMD,
  getTimeYMDS: getTimeYMDS,
  getTimehms:getTimehms,
  getTimehms_:getTimehms_,
  getTimeYDMS_:getTimeYDMS_,
  getTimeMDSlash_:getTimeMDSlash_,
  withdrawalStatus: withdrawalStatus,
  gameName: gameName,
  gameName2: gameName2,
  userName: userName,
  formatCurrency: formatCurrency,
  birthdayNumber: birthdayNumber,
  getTimeYMDSports,
  emailNum,
  slotgameType:slotgameType,
  depositOrderStatus:depositOrderStatus,
  INchangeTitle,
  INgameName,
  INbonusName,
  INbonusLockPlatform,
  INbonusLockStatus,
  INdepositLockStatus,
  INbankNumber,
  INColorLightStatus,
  gameHistoryStatus,
  INdepositstatus
}



// WEBPACK FOOTER //
// ./src/common/filter/infoFilter.js